import { useState, useEffect } from "react";
import { StriimMessageBox, StriimButton, StriimTypography } from "@striim/striim-ui";
import { Box, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import App from "app";

const styles = {
    wrapper: {
        position: "relative",
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "column",
        height: "calc(100vh - 48px)",
        top: 48,
        padding: ({ spacing }) => spacing(4)
    },
    header: { marginTop: 0, marginBottom: ({ spacing }) => `${spacing(2)} !important` },
    messageBoxOverrides: {
        "& .MuiCard-root": {
            backgroundColor: "#fff",
            border: ({ palette }) => `1px solid ${palette.greyscale[200]}`,
            boxShadow: "unset"
        },
        "& .MuiCardHeader-avatar": {
            alignSelf: "center",
            "& svg": {
                fill: ({ palette }) => palette.greyscale[600]
            }
        }
    }
};

export default function AlertPermissionDenied() {
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        App.content.empty();
    }, []);

    return (
        <Grid container sx={styles.wrapper}>
            <StriimTypography sx={styles.header} variant="h1">
                Alerts
            </StriimTypography>
            {!dismissed && (
                <Box sx={styles.messageBoxOverrides}>
                    <StriimMessageBox
                        type="INFO"
                        text={
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%"
                                }}
                            >
                                <StriimTypography variant="body4" sx={{ color: "#48525C" }}>
                                    You don't have permission to access this page. Contact your administrator to
                                    request access.
                                </StriimTypography>
                            </Box>
                        }
                    />
                </Box>
            )}
        </Grid>
    );
}
